import { Replay } from "@mui/icons-material"
import { Button } from "@mui/material/index"
import { useTranslation } from "react-i18next";

interface CBResetFiltersButtonProps {
    onClick: () => void
}

const CBResetFiltersButton = ({
    onClick

}: CBResetFiltersButtonProps) => {

    const { t } = useTranslation('customerbase');

    return (
        <Button 
            variant={"text"}
            color={"accent"}
            startIcon={<Replay/>}
            onClick={onClick}
        >
            {t("searchTooltip.clearFilters")}
        </Button>
    )
}

export default CBResetFiltersButton;